import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    Box,
    CssBaseline,
    Divider,
    Snackbar,
} from '@material-ui/core'
import { Info as InfoIcon } from '@material-ui/icons'

import { ColorPaper } from '../Atoms'

const useStyles = makeStyles(theme => ({
    container: {
        width: '50vw',
        minWidth: "800px",
        height: '33vh',
        minHeight: "260px",
        padding: "10px 20px",
    },
    openSnackbar: {
        display: 'block',
        position: 'static',
        transform: 'none',
    },
    closedSnackbar: {
        display: 'none',
    },
    divider: {
        width: 5,
        backgroundColor: theme.palette.primary.main,
    }
}))

const DisclaimerContent = React.forwardRef(({ children }, ref) => {
    const classes = useStyles()

    return <div ref={ref}>
        <ColorPaper style={{ padding: 0 }} elevation={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center" flexDirection="row"
                className={classes.container}>
                <Divider color="primary" orientation="vertical" flexItem className={classes.divider} />
                <InfoIcon color="primary" sx={{width: "3em", height:"3em"}}/>
                <Box display="flex" justifyContent="space-evenly" alignItems="center" flexDirection="column" style={{ height: "100%", width: "100%", maxWidth: 650 }}>
                    {children}
                </Box>
            </Box>
        </ColorPaper>
    </div>
})

const Disclaimer = ({ open, children }) => {
    const classes = useStyles()
    return (
        window.location.pathname!=="/cookies" &&
        <CssBaseline>
            <Snackbar
                open={open}
                transitionDuration={100}
                className={open ? classes.openSnackbar : classes.closedSnackbar}
            >
                <DisclaimerContent open={open}>
                    {children}
                </DisclaimerContent>
            </Snackbar >
        </CssBaseline>
    )

}

export default Disclaimer